@if(print && filter) {
<app-print-filter-data [filter]="filter" />
} @if (data) {

<div class="card">
  <p class="title">Analítico</p>
  <p>Compare resultados de unidades de pesquisas</p>
  <hr />
  <div class="count">
    <img src="assets/img/account_circle.png" alt="account_circle" />
    <p>{{ data.total }} respostas</p>

    <img class="scales" src="assets/img/Scales.png" alt="scales" />
    <p>{{ data.average }}% Média geral</p>
  </div>

  <div class="satis">Satisfação</div>

  <app-custom-bar-chart
    [dataType]="chartColorsEnum.singleColor"
    [data]="data.analyticalData"
  />
</div>
}
